import React from "react";

import { Container, Box, Grid, Snackbar, IconButton } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Close as CloseIcon } from '@material-ui/icons';

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as appActionCreators from "../../services/app/actions";

const PageScreen = (props) => {
  return (
    <div className={`Screen ${props.className}`}>
      {props.noContainer ?
        props.children
      :
        <Container maxWidth="xl" className="ContainerGrow">
          {props.children}
        </Container>
      }
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={props.services.app.snack?.open}
        autoHideDuration={6000}
        onClose={() => props.actions.app.closeSnack()}
      >
        <Alert onClose={() => props.actions.app.closeSnack()} severity={props.services.app.snack?.severity||'Info'}>
          {props.services.app.snack?.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default connect(
  (state, ownProps) => ({
    services: {
      app: state.services.app
    }
  }),
  (dispatch) => ({
    actions: {
      app: bindActionCreators(appActionCreators, dispatch),
    },
  })
)(PageScreen);
